document.addEventListener('DOMContentLoaded', function () {
    timelineContainerBlock()
})

function timelineContainerBlock() {
    const timelinesContainer = document.querySelectorAll('.timelines-block')
    if (timelinesContainer) {
        const timelines = document.querySelectorAll('.timeline-block')
        const selection = document.querySelector('#timelines-selection')

        // Create buttons from timelines
        timelines.forEach((el) => {
            const title = el.querySelector('.hidden-title').innerText
            const id = el.id
            let btn = document.createElement('button')
            btn.innerText = title
            btn.setAttribute('data-timeline', id)
            selection.appendChild(btn)
        })

        const buttons = document.querySelectorAll('#timelines-selection button')

        // Set initial selected timeline and button
        let selectedTimeline = timelines[0]
        if (selectedTimeline != null) {
            selectedTimeline.classList.add('is-selected')
        }
        let selectedBtn = buttons[0]
        if (selectedBtn != null) {
            selectedBtn.classList.add('is-selected')
        }

        function updateSelected(list, btn) {
            selectedBtn.classList.remove('is-selected')
            selectedTimeline.classList.remove('is-selected')

            list.classList.add('is-selected')
            btn.classList.add('is-selected')

            selectedTimeline = list
            selectedBtn = btn
        }

        // Add eventlistener to created buttons
        buttons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                if (e.currentTarget.getAttribute('data-timeline') !== selectedBtn.getAttribute('data-timeline')) {
                    let newTimeline = document.querySelector('#' + e.currentTarget.getAttribute('data-timeline'))
                    updateSelected(newTimeline, e.currentTarget)
                } else {
                    return
                }
            })
        })
    }
}
